<template>
  <div
    class="skeleton-box-one-string"
    :style="styles"
  />
</template>

<script>
export default {
  name: 'SkeletonOneString',

  props: {
    /**
     * @description Размер шрифта
     */
    fontSize: {
      type: Number,
      default: 16,
    },

    /**
     * @description Длина в символах
     */
    length: {
      type: Number,
      default: 24,
    },
    /**
     * @description Переопределение значения стилей внешних отсупов margin
     */
    margin: {
      type: [String, Number],
    },

    /**
     * @description Ширина в пикселях или в относительных единицах
     */
    width: {
      type: String,
      default: '',
    },

    /**
     * @description Высота в пикселях
     */
    height: {
      type: Number,
      default: 0,
    },

    /**
     * @description Скругление углов в пикселях
     */
    borderRadius: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    computedWidth () {
      if (this.width) {
        return this.width
      }
      return `${this.length * 8.4 / 100}rem`
    },

    computedHeight () {
      if (this.height) {
        return this.height + 'px'
      }
      return `0.${this.fontSize}rem`
    },

    styles () {
      return {
        width: this.computedWidth,
        height: this.computedHeight,
        margin: this.margin,
        borderRadius: this.borderRadius + 'px',
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@/assets/styles/core/skeleton.scss';
.skeleton-box-one-string-wrapper {
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
}
.skeleton-box-one-string {
  @extend %skeleton-class;
}
</style>
